<!-- eslint-disable vue/no-v-html -->
<template>
    <div class="ers-page-content">
        <div class="ers-page-title">
            <h1>
                {{ $t('energy.roof_insulation.question') }}
                <Tooltip :html="$t('energy.roof_insulation.tooltip_popup')" />
            </h1>
        </div>

        <div class="ers-page-info">
            <img src="@/assets/icons/ic-lightbulb.svg" alt="" srcset="" />
            <p v-html="$t('energy.roof_insulation.info_bubble')"></p>
        </div>

        <div class="ers-page-section">
            <yes-no v-model="roof_attributes[0].has_insulation" :idk-enabled="true" />
        </div>

        <div v-if="roof_attributes[0].has_insulation === true" class="ers-page-section">
            <h1 class="has-text-weight-medium has-text-black input-instructions">
                {{ $t('energy.roof_insulation.question_2') }}
            </h1>
            <year-selector
                v-model="roof_attributes[0].renovation_year"
                :minimum="getFeatures.f_construction_year || 1800"
                :label="$t('energy.roof_insulation.label_input')"
            />
        </div>

        <div class="column is-12 mt-2">
            <div class="is-flex is-justify-content-space-between">
                <b-button
                    size="is-medium"
                    type="is-dark"
                    icon-left="arrow-left"
                    @click="changePage(false)"
                >
                    {{ $t('common.previous') }}
                </b-button>
                <submit-button
                    @on-click="
                        $emit('open-summary-modal', {
                            unsubmit: false,
                        })
                        changePage(true)
                    "
                />
                <b-button
                    v-if="showNextButton"
                    :class="{ 'ers-next-bttn-dark': hasRequestBeenUnsubmitted }"
                    size="is-medium"
                    type="is-primary"
                    icon-right="arrow-right"
                    @click="changePage(true)"
                >
                    <span>{{ $t('common.next') }}</span>
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import YesNo from '../../elements/YesNo.vue'
import YearSelector from '../../elements/YearSelector.vue'
import Tooltip from '../../elements/Tooltip'
import SubmitButton from '../../elements/SubmitButton'

export default {
    name: 'RoofInsulation',
    components: {
        YesNo,
        YearSelector,
        SubmitButton,
        Tooltip,
    },
    props: {
        proceedFn: {
            type: Function,
            required: false,
            default: null,
        },
        cancelFn: {
            type: Function,
            required: false,
            default: null,
        },
    },
    data: () => ({
        roof_attributes: [
            {
                has_renovation: null,
                has_insulation: null,
                renovation_year: null,
            },
        ],
        isRoofModalActive: false,
        isFirstPass: true,
    }),
    computed: {
        ...mapGetters('ersStore', [
            'getFeatures',
            'getRoofInsulation',
            'getOtherData',
            'hasRequestBeenUnsubmitted',
        ]),
        showNextButton() {
            if (
                this.roof_attributes[0].has_insulation === false ||
                this.roof_attributes[0].has_insulation === 'idk'
            )
                return true
            if (
                this.roof_attributes[0].has_insulation &&
                this.roof_attributes[0].has_renovation === false
            )
                return true
            if (
                this.roof_attributes[0].has_insulation &&
                // this.roof_attributes[0].has_renovation &&
                this.roof_attributes[0].renovation_year >=
                    this.getFeatures.f_construction_year
            )
                return true
            return false
        },
    },
    mounted() {
        const prevValue = this.getRoofInsulation[0]
        if (prevValue.has_insulation !== null) {
            this.isFirstPass = false
        }
        this.roof_attributes[0].has_insulation = prevValue.has_insulation

        if (prevValue.has_renovation !== null) {
            this.isFirstPass = false
        }
        this.roof_attributes[0].has_renovation = prevValue.has_renovation

        if (!prevValue.renovation_year) {
            this.roof_attributes[0].renovation_year = this.getFeatures.f_construction_year
        } else {
            this.roof_attributes[0].renovation_year = prevValue.renovation_year
        }

        // https://stackoverflow.com/a/56571537/16901626
        this.$watch(
            () => this.roof_attributes[0].has_insulation,
            function(val) {
                if (val === false || val === 'idk') {
                    this.roof_attributes[0].has_renovation = false
                    this.roof_attributes[0].renovation_year = null
                    if (this.isFirstPass) {
                        this.changePage(true)
                    } else {
                        this.isFirstPass = true
                    }
                } else {
                }
            }
        )
        this.$watch(
            () => this.roof_attributes[0].has_renovation,
            function(val) {
                if (val === false) {
                    this.roof_attributes[0].renovation_year = this.getFeatures.f_construction_year
                    if (this.isFirstPass) {
                        this.changePage(true)
                    } else {
                        this.isFirstPass = true
                    }
                }
            }
        )
    },
    methods: {
        ...mapMutations('ersStore', ['SET_FEATURES']),
        ...mapActions('ersStore', ['set_and_submit_feature']),
        changePage(isNextPage) {
            const nextPage = isNextPage ? 'ers.wall-insulation' : 'ers.construction-year'
            const feature = {
                roof_attributes: this.roof_attributes,
            }

            this.set_and_submit_feature({
                feature,
                nextPage,
            })

            this.$router.push({
                name: nextPage,
                params: {
                    lang: this.$route.params.lang,
                },
                query: this.$route.query,
            })
        },
    },
}
</script>

<style lang="scss">
@import '@/shared/assets/style/buefy.scss';
.grid-center {
    justify-self: center;
    align-self: center;
    text-align: center;
}

.insulation-grid {
    display: grid;
    grid-template-columns: minmax(240px, max-content) repeat(4, auto);
    grid-template-rows: repeat(4, auto);
    gap: 1rem;
}

.glazing-grid {
    display: grid;
    grid-template-columns: minmax(240px, max-content) repeat(1, auto);
    grid-template-rows: repeat(2, auto);
    gap: 0.5rem 1rem;
    align-items: end;
}

.attic-grid {
    display: grid;
    grid-template-columns: minmax(240px, max-content) repeat(2, auto);
    grid-template-rows: auto;
    gap: 1rem;

    .heated-attic-input {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        h4 {
            margin-right: 1rem;
        }
    }
}

.basement-grid {
    display: grid;
    grid-template-columns: minmax(240px, max-content) auto;
    grid-template-rows: auto;
    gap: 1rem;
}

.separator {
    width: 100%;
    height: 1px;
    margin: 1rem 1.5rem;
    background: #d6e2e9;
}

.is-small-tooltip {
    font-size: 14px;
    .info {
        height: 20px;
        width: 20px;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
.is-tootip-btn {
    height: 24px;
    width: 24px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
